import './index.scss'
import { Controller as BaseController } from 'stimulus'
import Highcharts from 'highcharts'
import NoDataToDisplay from 'highcharts/modules/no-data-to-display'

export class Controller extends BaseController {
  static values = {
    donutData: Array,
    donutSize: Number,
    subtitle: String,
    innerSize: String,
    title: String,
    visible: Boolean,
    placeholderText: String
  }

  connect() {
    NoDataToDisplay(Highcharts)
    Highcharts.chart(this.element, {
      chart: {
        type: 'pie',
        spacingBottom: 0,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        marginBottom: 0,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0
      },
      title: {
        text: null
      },
      subtitle: {
        text: this.subtitleValue,
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '18px',
          font: 'normal 1rem "Uni Neue", Helvetica, Arial, sans-serif',
          textAlign: 'center'
        },
        x: 0,
        y: 16
      },
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      xAxis: {
        visible: false
      },
      plotOptions: {
        pie: {
          innerSize: this.innerSizeValue,
          dataLabels: {
            enabled: false
          }
        },
        series: {
          animation: false,
          enableMouseTracking: false,
          size: this.donutSizeValue
        }
      },
      series: [{
        data: this.donutDataValue,
        visible: this.visibleValue
      }],
      lang: {
        noData: this.placeholderTextValue
      },
      noData: {
        style: {
          fontWeight: '400',
          fontSize: '35px',
          color: '#000000',
          fontFamily: 'Uni Neue'
        }
      }
    })
  }
}
